import { render, staticRenderFns } from "./site-inquiry.vue?vue&type=template&id=2fd50621&"
import script from "./site-inquiry.vue?vue&type=script&lang=js&"
export * from "./site-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports